import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Keeps a signed-in user out of the app until they have accepted the current terms of use.
 * Runs after `authGuard`, on every protected route, so it covers a first login, a session that
 * outlived a change of the terms, and a deep link alike — the acceptance page brings the user
 * back to `returnUrl` afterwards.
 */
export const termsGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.hasAcceptedCurrentTerms()) {
    return router.createUrlTree(['/prijeti-podminek'], { queryParams: { returnUrl: state.url } });
  }
  return true;
};
